import { TECHNICIAN_PREVISAO_SESSIONS } from '../constants/technicianMenuConstants';
import {
  getAllTechnicianOrdersForCondtTabs,
  matchesCondtLiberado,
  matchesCondtPendente,
} from '../utils/futuraRetornoCondt';

function technicianHasFuturaInbox(technicianGroups, technician) {
  const orders = getAllTechnicianOrdersForCondtTabs(technicianGroups, technician);
  return orders.some((order) => matchesCondtPendente(order) || matchesCondtLiberado(order));
}

/** Chaves de previsão com ao menos 1 OS em qualquer coluna de técnico. */
export function getAvailablePrevisaoKeys(technicianGroups) {
  const available = new Set();
  const groupsByTech = technicianGroups || {};
  Object.entries(groupsByTech).forEach(([technician, groups]) => {
    TECHNICIAN_PREVISAO_SESSIONS.forEach((key) => {
      if (Array.isArray(groups?.[key]) && groups[key].length > 0) {
        available.add(key);
      }
    });
    if (!available.has('FUTURA') && technicianHasFuturaInbox(groupsByTech, technician)) {
      available.add('FUTURA');
    }
  });
  return TECHNICIAN_PREVISAO_SESSIONS.filter((k) => available.has(k));
}

/**
 * Seleção subtrativa: opções disponíveis entram aplicadas;
 * o usuário só remove; chaves novas reaparecendo entram selecionadas.
 * Se a seleção estiver vazia e houver opções, preenche todas.
 */
export function nextPrevisaoSelection(current, nextAvailable, newlyAppeared = []) {
  if (!nextAvailable.length) return [];
  const cur = Array.isArray(current) ? current : [];
  if (!cur.length) return [...nextAvailable];

  let next = cur.filter((k) => nextAvailable.includes(k));
  newlyAppeared.forEach((k) => {
    if (nextAvailable.includes(k) && !next.includes(k)) next.push(k);
  });
  if (!next.length) return [...nextAvailable];
  return nextAvailable.filter((k) => next.includes(k));
}

export function previsaoSelectionEquals(a, b) {
  const left = Array.isArray(a) ? a : [];
  const right = Array.isArray(b) ? b : [];
  if (left.length !== right.length) return false;
  return left.every((k) => right.includes(k)) && right.every((k) => left.includes(k));
}
